import _ from 'lodash/fp'

export const getFileList = (e) => {
  const dataTransfer = e.dataTransfer
  if (dataTransfer) {
    if (isFolderDropSupported(dataTransfer)) {
      return Promise.all(
        Array.from(dataTransfer.items)
          .map(item => getFilesFromEntry(item.webkitGetAsEntry(),item))
      ).then(nestedArrays =>
        _.flatten(nestedArrays)
      )
    } else {
      return Promise.resolve(Array.from(dataTransfer.files))
    }
  }
  return Promise.resolve(Array.from(e.target.files))
}

const getFilesFromEntry = (entry,item) => {
  if (entry) {
    if (entry.isFile) {
      if (item) {
        return Promise.resolve([item.getAsFile()])
      }
      return new Promise((resolve) =>
        entry.file(
          (file) => resolve([file]),
          (fileError) => resolve([]) /* handle error */
        )
      )
    } else if (entry.isDirectory) {
      return getFilesInDirectory(entry)
    } else {
      /* handle error */
      return Promise.resolve([])
    }
  } else {
    /* handle error  */
    return Promise.resolve([])
  }
}

const isFolderDropSupported = (dataTransfer) =>
  dataTransfer.items && dataTransfer.items.length > 0 && dataTransfer.items[0].webkitGetAsEntry


const getFilesInDirectory = (entry) =>
  new Promise((res) => {
    const dirReader = entry.createReader();
    let entries = []

    const getEntries = () => {
      dirReader.readEntries((results) => {
        if (results.length) {
          entries = entries.concat(Array.from(results));
          getEntries();
        } else {
          res(entries)
        }
      }, (error) => {
        res(entries)
        /* handle error -- error is a FileError object */
      })
    };
    getEntries()
  }).then(entries =>
    Promise.all(entries.map(entry => getFilesFromEntry(entry)))
      .then(nestedArrays =>
        _.flatten(nestedArrays)
      )
  )

